import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { PanelComponent } from 'components/layout/panel/panel.component';

@Component({
	template: '<panel>@if (safeUrl) {<iframe [src]="safeUrl"></iframe>}</panel>',
	imports: [PanelComponent]
})
export class IframePanelComponent {
	@Input() set url(url: string) {
		this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
	}
	public safeUrl?: SafeUrl;

	constructor(private readonly sanitizer: DomSanitizer) { }
}
